import ListFilters from "@/common/components/ListFilters";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { dashboardFilters } from "@/features/company/constants/dashboards/dashboardFilters.constant";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";
import { useEquipmentCategories } from "@/features/equipments/hooks/useEquipmentCategories";
import { EquipmentCategoryData } from "@/features/equipments/types/equipments.type";

const DashboardFilterEquipmentCategoryBadge = ({ filters, setFilters }: DashboardFilterProps) => {
  const [search, setSearch] = useDebounce('');

  const {
    data: equipmentCategoriesOptions,
  } = useEquipmentCategories({
    filters: {
      search,
    },
    mapper: Mapper.mapToOptions<EquipmentCategoryData>({
      labelFieldName: 'display_name',
      valueFieldName: 'id',
    }),
  });

  return (
    <ListFilters
      filters={[
        {
          className: 'bg-blue-200/20 rounded-xl shadow-none max-w-[200px] text-nowrap',
          placeholder: dashboardFilters[DashboardFilters.EquipmentCategory],
          options: [{ label: 'Todas', value: '' }, ...equipmentCategoriesOptions],
          value: filters[DashboardFilters.EquipmentCategory],
          onChange: (e: any) => setFilters((prev) => ({ ...prev, [DashboardFilters.EquipmentCategory]: e?.value ? e : null })),
          onInputChange: setSearch,
        }
      ]}
    />
  );
}

export default DashboardFilterEquipmentCategoryBadge;
